import { lazy, Suspense, useEffect, useState } from "react";

const OfferRedeemDialog = lazy(() => import("./OfferRedeemDialog"));

export type OfferRedeemRequest = {
  code?: string;
  note?: string;
};

function requestFromLocation(): OfferRedeemRequest | null {
  try {
    const search = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    const hashQueryStart = hash.indexOf("?");
    const hashSearch = new URLSearchParams(hashQueryStart >= 0 ? hash.slice(hashQueryStart + 1) : "");
    const code = (search.get("discount") || hashSearch.get("discount") || "").toUpperCase();
    return code ? { code } : null;
  } catch {
    return null;
  }
}

/** Keeps the offer feature out of the public entry chunk until it is requested. */
export function LazyOfferRedeemDialog() {
  const [request, setRequest] = useState<OfferRedeemRequest | null>(() => requestFromLocation());

  useEffect(() => {
    const onLocationChange = () => setRequest(requestFromLocation());
    const onOpen = (event: Event) => {
      const detail = (event as CustomEvent<OfferRedeemRequest>).detail ?? {};
      setRequest({ code: detail.code?.toUpperCase(), note: detail.note });
    };

    window.addEventListener("hashchange", onLocationChange);
    window.addEventListener("open-offer-redeem", onOpen as EventListener);
    return () => {
      window.removeEventListener("hashchange", onLocationChange);
      window.removeEventListener("open-offer-redeem", onOpen as EventListener);
    };
  }, []);

  if (!request) return null;
  return (
    <Suspense fallback={null}>
      <OfferRedeemDialog request={request} />
    </Suspense>
  );
}
